export const en = {
    connectedAppConnect: {
        success: "{{app}} connected successfully.",
        error: "Couldn't connect {{app}}. Please try again.",
        popupBlocked: "Allow pop-ups for this site to connect {{app}}.",
        popupLoading: "Connecting…",
        unsupported: "This app can't be connected from Workleap yet."
    }
};
